import React, { useEffect, useState } from "react";
import { Table } from 'rsuite';
const {Column,HeaderCell,Cell}=Table;
type attributes = {
  members:any,
  
}
export const ProcessTeamMembers=(props:attributes)=>{
    return(
      <Table
      height={300}
     
    data={props.members}
    
  >
    <Column resizable flexGrow={70} align="center" fixed>
      <HeaderCell>ID</HeaderCell>
      <Cell dataKey="EmployeeId" />
    </Column>
    <Column  resizable flexGrow={200} fixed>  
      <HeaderCell>Name</HeaderCell>
      <Cell dataKey="EmployeeName" />
    </Column>
    <Column flexGrow={150} fixed>
      <HeaderCell>TEAM</HeaderCell>
      <Cell dataKey="Team" />
    </Column>
    <Column flexGrow={100} fixed>
      <HeaderCell>PROCESS</HeaderCell>
      <Cell dataKey="Process" />
    </Column>
    <Column flexGrow={110}>
      <HeaderCell>ALLOCATION%</HeaderCell>
      <Cell dataKey="allocation" />
    </Column>
    <Column flexGrow={120}>
      <HeaderCell>BUFFER%</HeaderCell>
      <Cell dataKey="buffer" />
    </Column>
  </Table>
    )
}